import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConversorService {

  categoriesUrl = environment.API_URL+"/Conversion/GetBalances";
  conversionTypesUrl = environment.API_URL+"/quoteratio";
  conversionUrl = environment.API_URL+"/Conversion/GetExchange";

  constructor(private http : HttpClient) {

   }

  getConversionTypes(): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    })
    return this.http.get(this.conversionTypesUrl,{ headers: headers });
  }
  getAll(): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    })
    return this.http.get(this.categoriesUrl,{ headers: headers });
  }
  convert(convertParams: any): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    })
    return this.http.get(this.conversionUrl + `?type=${convertParams.type}&quantity=${convertParams.quantity}`,{ headers: headers});
  }

}